module.exports = __webpack_public_path__ + "img/1537486901.3377aeee.jpg";